import { useEffect, useState } from "react";
import { useWindowSize } from "../hooks/useWindowSize";

export const AppContentContainer = ({ children }: any) => {
  const { appContentContainerWidth, appContentContainerHeight } =
    useWindowSize();

  return (
    <div
      id="AppContentContainer"
      {...{
        style: {
          fontFamily: "DM Sans, Avenir, Arial, sans-serif",
          borderRadius: "0.75rem",
          overflow: "hidden",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          width: appContentContainerWidth,
          height: appContentContainerHeight,
          display: "grid",
          gridTemplate: `
            "AppContentContainer" minmax(0, 1fr)
          ` /* https://stackoverflow.com/questions/43311943/prevent-content-from-expanding-grid-items */,
        },
      }}
    >
      {children}
    </div>
  );
};
